import type { ChipFilterValue, FilterConfig, NumberFilterConfig } from '@openx/types/chipFilters.ts';
import type { ConstValues } from '@openx/types/helpers.ts';

export const NumberFilterFields = {
  OPTION: 'OPTION',
  VALUE: 'VALUE',
  VALUE_TO: 'VALUE_TO',
} as const;
export type NumberFilterFields = ConstValues<typeof NumberFilterFields>;

export interface NumberFilterData {
  [NumberFilterFields.OPTION]: null | RangeOptions;
  [NumberFilterFields.VALUE]: string;
  [NumberFilterFields.VALUE_TO]: string;
}

export const RangeOptions = {
  GT: 'GT',
  LT: 'LT',
  RANGE: 'RANGE',
  EQUAL: 'EQUAL',
} as const;
export type RangeOptions = ConstValues<typeof RangeOptions>;

export interface NumberFilterProps extends NumberFilterConfig, Pick<FilterConfig, 'onInputChange' | 'name'> {
  setCurrentOption: (val: ChipFilterValue) => void;
  setError: (val: boolean) => void;
}
